import { GxNumberFormat } from '@garpix/garpix-web-components-react';
import React from 'react';

const InputNumbers = ({
  children,
  handleChange,
  handleInput,
  className,
  ...props }: any) => {
  return (
    <GxNumberFormat
      onGx-input={handleInput}
      onGx-change={handleChange}
      thousandSeparator=''
      className={className}
      {...props}
    >
      {children}
    </GxNumberFormat>
  );
};

export default InputNumbers;
